import baseAPI from '@/api/base';
import { AttendanceAnalyticsParams, GetAttendanceLog, RegisterAttendanceLog } from '@/dtos/attendance_log.dto';
import {
  EXPORT_ATTENDANCE_URL,
  GET_ATTENDANCE_ANALYTICS_URL,
  GET_ATTENDANCE_DAY_RECORDS_URL,
  GET_ATTENDANCE_LOG_URL,
  GET_ATTENDANCE_REPORT_URL,
  GET_CALENDAR_ATTENDANCE_LOG_URL,
  GET_EMPLOYEE_ATTENDANCE_DAY_URL,
  GET_EMPLOYEE_ATTENDANCE_LOG_URL,
  REGISTER_ATTENDANCE_LOG_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class AttendanceLog {
  static getAttendanceLogs = async (
    getAttendanceLog: GetAttendanceLog
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_ATTENDANCE_LOG_URL, {
      params: getAttendanceLog,
    });
    console.log('response', response);
    return response;
  };

   static registerAttendanceLog = async (
    registerAttendanceLog: RegisterAttendanceLog
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_ATTENDANCE_LOG_URL, {
      ...registerAttendanceLog,
    });
    console.log('response', response);
    return response;
  };

  static getEmployeeAttendanceLogs = async (
    getAttendanceLog: GetAttendanceLog
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_ATTENDANCE_LOG_URL, {
      params: getAttendanceLog,
    });
    console.log('response', response);
    return response;
  };

  static getEmployeeAttendanceDays = async (
    getAttendanceLog: GetAttendanceLog
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_ATTENDANCE_DAY_URL, {
      params: getAttendanceLog,
    });
    console.log('response', response);
    return response;
  };

  static getCalendarAttendanceLogs = async (
    getAttendanceLog: GetAttendanceLog
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_CALENDAR_ATTENDANCE_LOG_URL, {
      params: getAttendanceLog,
    });
    console.log('response', response);
    return response;
  };

  static getAttendanceAnalytics = async (params: AttendanceAnalyticsParams): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_ATTENDANCE_ANALYTICS_URL, { params });
    return response;
  };

  static getAttendanceDayRecords = async (params: AttendanceAnalyticsParams): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_ATTENDANCE_DAY_RECORDS_URL, { params });
    return response;
  };

  static exportAttendance = async (params: AttendanceAnalyticsParams): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(EXPORT_ATTENDANCE_URL, { params, responseType: 'blob' });
    return response;
  };

  static getAttendanceReport = async (
    getAttendanceLog: GetAttendanceLog
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_ATTENDANCE_REPORT_URL, {
      params: getAttendanceLog,
    });
    console.log('response', response);
    return response;
  };
}

export default AttendanceLog;
